import React from 'react'
import { GlobalStyle } from './GlobalSyled'
import Home from './Pages/Home'

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Home />
    </>
  )
}

export default App
